export function mapFields(obj, mapping) {
    if (!obj) {
        return obj;
    }

    return Object.keys(obj).reduce((group, key) => {
        const groupKey = key in mapping ? mapping[key] : key;
        return {
            ...group,
            [groupKey]: obj[key]
        };
    }, {});
}
